module.exports = __webpack_public_path__ + "media/images/products/igood-mobile-5657346922ec306574930d7b64f84c24.png";